"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapInspiration = function mapInspiration(inspiration) {
  var _inspiration$primary$, _inspiration$primary$2, _inspiration$primary, _inspiration$primary$3, _inspiration$primary$4;
  return {
    cardLink: (_inspiration$primary$ = inspiration.primary.url) !== null && _inspiration$primary$ !== void 0 && _inspiration$primary$.url ? inspiration.primary.url.url.replace("https:/", "") : "/",
    title: inspiration.primary.title && ((_inspiration$primary$2 = inspiration.primary.title) === null || _inspiration$primary$2 === void 0 ? void 0 : _inspiration$primary$2[0].text),
    bloggerId: (_inspiration$primary = inspiration.primary) !== null && _inspiration$primary !== void 0 && _inspiration$primary.blogger && inspiration.primary.blogger.id ? inspiration.primary.blogger.id : 0,
    mainImage: ((_inspiration$primary$3 = inspiration.primary.mainimage) === null || _inspiration$primary$3 === void 0 ? void 0 : _inspiration$primary$3.url) && (0, _image["default"])(inspiration.primary.mainimage, ((_inspiration$primary$4 = inspiration.primary.blurhash) === null || _inspiration$primary$4 === void 0 ? void 0 : _inspiration$primary$4.length) > 0 && inspiration.primary.blurhash[0].text),
    thumbnails: (inspiration === null || inspiration === void 0 ? void 0 : inspiration.items.length) > 0 && inspiration.items.map(function (image) {
      return (0, _image["default"])(image.thumbnails);
    })
  };
};
var _default = mapInspiration;
exports["default"] = _default;